"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var styles_1 = require("@material-ui/core/styles");
var reserveOnlineStyles = styles_1.makeStyles(function (theme) { return ({
    paragraph: {
        margin: theme.spacing(2) + " 0 " + theme.spacing(2) + " 0",
    },
}); }, { name: 'Checkout_ConfirmationReserveOnline' });
exports.default = reserveOnlineStyles;
